/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActivateSageIntacctInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type activateSageIntacctMutationVariables = {|
  input: ActivateSageIntacctInput
|};
export type activateSageIntacctMutationResponse = {|
  +activateSageIntacct: ?{|
    +outcome: ?string,
    +company: ?{|
      +id: string,
      +sageIntacctEnabled: ?boolean,
      +workatoCustomerId: ?string,
      +workatoForecastSageIntacctConnectionId: ?string,
      +workatoSageIntacctConnectionId: ?string,
      +workatoIframeToken: ?string,
    |},
  |}
|};
export type activateSageIntacctMutation = {|
  variables: activateSageIntacctMutationVariables,
  response: activateSageIntacctMutationResponse,
|};
*/


/*
mutation activateSageIntacctMutation(
  $input: ActivateSageIntacctInput!
) {
  activateSageIntacct(input: $input) {
    outcome
    company {
      id
      sageIntacctEnabled
      workatoCustomerId
      workatoForecastSageIntacctConnectionId
      workatoSageIntacctConnectionId
      workatoIframeToken
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateSageIntacctInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ActivateSageIntacctPayload",
    "kind": "LinkedField",
    "name": "activateSageIntacct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sageIntacctEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoCustomerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoForecastSageIntacctConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoSageIntacctConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoIframeToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateSageIntacctMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activateSageIntacctMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "activateSageIntacctMutation",
    "operationKind": "mutation",
    "text": "mutation activateSageIntacctMutation(\n  $input: ActivateSageIntacctInput!\n) {\n  activateSageIntacct(input: $input) {\n    outcome\n    company {\n      id\n      sageIntacctEnabled\n      workatoCustomerId\n      workatoForecastSageIntacctConnectionId\n      workatoSageIntacctConnectionId\n      workatoIframeToken\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'adce9a6de6c069b858ae3c10628eeeb4';

module.exports = node;
